import request from '@/utils/request'

// 获取用户列表
export function getUserList() {
	return request({
		url: '/user/getUserList',
		method: 'get'
	})
}

// 获取人员工作统计数据
export function getWorkStatistics(data) {
	return request({
		url: '/user/getUserWork',
		method: 'post',
		data
	})
}

// 获取客户跟进记录
export function getCustomerFollowUps(data) {
	return request({
		url: '/user/getUserActivity',
		method: 'post',
		data
	})
}

// 获取商机转化记录
export function getOpportunityConversions(data) {
	return request({
		url: '/user/getUserBusiness',
		method: 'post',
		data
	})
}

// 获取合同签订记录
export function getContractSignings(data) {
	return request({
		url: '/user/getUserContract',
		method: 'post',
		data
	})
}

export function getPaymentRecords(data) {
	return request({
		url: '/user/getPaymentRecords',
		method: 'post',
		data
	})
}

export function getOpportunityList(params) {
	return request({
		url: '/move/getOpportunityList',
		method: 'get',
		params
	})
}

export function getOpportunityAnalysis(params) {
	return request({
		url: '/move/getOpportunityAnalysis',
		method: 'get',
		params
	})
}

export function getOpportunityFollowUps(data) {
	return request({
		url: '/move/getOpportunityFollowUps',
		method: 'post',
		data
	})
}

// 获取团队成员列表
export function getBusinessTeam(params) {
	return request({
		url: '/user/getBusinessTeam',
		method: 'get',
		params
	})
}

export function getStaUser(data) {
	return request({
		url: '/user/getStaUser',
		method: 'post',
		data
	})
}


export function getBusinessDetail(params) {
	return request({
		url: '/move/getBusinessDetail',
		method: 'get',
		params
	})
}

export function getBusinessOffer(params) {
	return request({
		url: '/move/getBusinessOffer',
		method: 'get',
		params
	})
}

export function getBusinessContract(params) {
	return request({
		url: '/move/getBusinessContract',
		method: 'get',
		params
	})
}

export function getBusinessRec(params) {
	return request({
		url: '/move/getBusinessRec',
		method: 'get',
		params
	})
}

export function getExamineList(params) {
  return request({
    url: `/move/getOfferApp`,
    method: 'get',
    params: params
  })
} 

export function getExamineFlowDetail(params) {
  return request({
    url: '/move/getExamineFlowDetail',
    method: 'get',
    params
  })
}